import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["aria-hidden", "aria-label"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
import { computed } from 'vue';
import { CATEGORY_ICONS, getCategoryIconAsset, getCategoryIconSvg, isLegacyFontAwesomeIcon, resolveCategoryIconId, } from '../config/categoryIconRegistry';
import { buildCategoryIconProgrammaticSvgHtml, buildCategoryIconSvgHtml, } from '../utils/parseCategoryIconSvgAsset';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryIcon',
    props: {
        icon: { default: '' },
        color: { default: '' },
        size: { default: '' },
        padding: { default: '' },
        inline: { type: Boolean, default: true },
        decorative: { type: Boolean, default: true },
        ariaLabel: { default: '' },
        iconClass: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const legacyFa = computed(() => isLegacyFontAwesomeIcon(props.icon));
        const iconAsset = computed(() => getCategoryIconAsset(props.icon));
        const svgInner = computed(() => getCategoryIconSvg(props.icon) || '');
        const iconAssetHtml = computed(() => {
            const asset = iconAsset.value;
            return asset ? buildCategoryIconSvgHtml(asset) : '';
        });
        const programmaticIconHtml = computed(() => buildCategoryIconProgrammaticSvgHtml(svgInner.value));
        const iconLabel = computed(() => {
            const id = resolveCategoryIconId(props.icon);
            return CATEGORY_ICONS.find((entry) => entry.id === id)?.label || 'Kategorie';
        });
        const rootStyle = computed(() => {
            const style = {};
            if (props.color?.trim())
                style.color = props.color.trim();
            if (props.size?.trim())
                style['--category-icon-size'] = props.size.trim();
            if (props.padding?.trim())
                style['--category-icon-padding'] = props.padding.trim();
            return style;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["category-icon", [_ctx.inline ? 'category-icon--inline' : 'category-icon--block', _ctx.iconClass]]),
                style: _normalizeStyle(rootStyle.value),
                "aria-hidden": _ctx.decorative ? 'true' : undefined,
                "aria-label": _ctx.decorative ? undefined : _ctx.ariaLabel || iconLabel.value,
                role: "img"
            }, [
                (legacyFa.value)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass([_ctx.icon, "category-icon__fa"])
                    }, null, 2 /* CLASS */))
                    : (iconAssetHtml.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "category-icon__host",
                            "aria-hidden": "true",
                            innerHTML: iconAssetHtml.value
                        }, null, 8 /* PROPS */, _hoisted_2))
                        : (programmaticIconHtml.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "category-icon__host",
                                "aria-hidden": "true",
                                innerHTML: programmaticIconHtml.value
                            }, null, 8 /* PROPS */, _hoisted_3))
                            : _createCommentVNode("v-if", true)
            ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1));
        };
    }
});
